module.exports = __webpack_public_path__ + "static/media/search.d124570d.svg";